<mat-card style="box-shadow:none;     height: auto;" [class.mat-elevation-z1]="'true'" *ngIf="loading">
    <mat-card-header class="altmodalheader">
        <span mat-card-avatar>
            <mat-icon>date_range</mat-icon>
        </span>
        <mat-card-title>{{context}}: {{amcoId}} - {{tourType}}</mat-card-title>
    </mat-card-header>

    <div *ngIf="!tour?.customerContactEmail || tour.customerContactEmail.trim() === ''" style="background: #fff3cd; color: #856404; border: 1px solid #ffeeba; padding: 8px 12px; margin: 0 16px 8px 16px; border-radius: 4px; font-size: 14px;">
        <strong>Notice!</strong> This customer has no contact details loaded – please send manual updates.
        <button mat-stroked-button color="primary" style="margin-left: 12px;" (click)="openEmailDialog()">Set Email</button>
    </div>

    <mat-divider></mat-divider>


    <mat-dialog-content style="max-height: 71vh !important;
    overflow-x: hidden;

    margin-right: -40px !important;
    padding-right: 25px !important;">
        <mat-form-field class="updateformfield" style="min-width:180px;  padding-top: 15px;">
            <mat-label style="font-size: 15px !important;">Update Type</mat-label>
            <mat-select style="font-size: 15px !important;" [(value)]="updateType" panelClass="custom-panel" (selectionChange)="OnChanges()">
                <mat-option *ngIf="!isEdit" [value]="updateType">-- Select --</mat-option>
                <mat-option style=" font-size: 15px !important;" *ngFor="let option of updateTypes" [value]="option.id">
                   {{ option.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div *ngIf="showDelDates">
            <div *ngIf="showDelivery">
                <mat-form-field class="pds">
                    <mat-label style="font-size: 15px !important;">Planned Delivery Start</mat-label>
                    <input matInput [disabled]="true" [(ngModel)]="plannedDeliveryStart">
                </mat-form-field>

                <mat-form-field class="pde">
                    <mat-label style="font-size: 15px !important;">Planned Delivery End</mat-label>
                    <input matInput [disabled]="true" [(ngModel)]="plannedDeliveryEnd">
                </mat-form-field>
            </div>

            <div *ngIf="!showDelivery">
                <mat-form-field class="pls">
                    <mat-label style="font-size: 15px !important;">Planned Loading Start</mat-label>
                    <input matInput [disabled]="true" [(ngModel)]="plannedLoadingStart">
                </mat-form-field>

                <mat-form-field class="ple">
                    <mat-label style="font-size: 15px !important;">Planned Loading End</mat-label>
                    <input matInput [disabled]="true" [(ngModel)]="plannedLoadingEnd">
                </mat-form-field>
            </div>
        </div>

        <div *ngIf="addReason">
            <mat-form-field class="pls">
                <mat-label style="font-size: 15px !important;">Issue Status</mat-label>
                <mat-select [(value)]="issueStatus" panelClass="custom-panel">
                    <mat-option value="open">Open</mat-option>
                    <mat-option value="closed">Closed</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="ple">
                <mat-label style="font-size: 15px !important;">Priority</mat-label>
                <mat-select [(value)]="priority" panelClass="custom-panel">
                    <mat-option value="low">Low</mat-option>
                    <mat-option value="high">High</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="ple2">
                <mat-label style="font-size: 15px !important;">Who is the cause of the issue?</mat-label>
                <mat-select [(value)]="causeOfIssue">
                    <mat-option *ngFor="let option of causeOfIssueTypesList" [value]="option.name">
                        {{ option.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <div style="      font-size: 15px;  padding-bottom: 20px;">
                <mat-checkbox [(ngModel)]="issueRaisedByCustomer" class="custom-checkbox tester">Was the issue raised by the Customer?</mat-checkbox>
            </div>

            <div style="font-size: 15px; padding-bottom: 20px;">
                <label style="display:block; margin-bottom:6px;">Has Customer been called?</label>
                <mat-radio-group [(ngModel)]="hasCustomerBeenCalled" name="hasCustomerBeenCalled">
                    <mat-radio-button value="yes" style="margin-right:12px;">Yes</mat-radio-button>
                    <mat-radio-button value="no">No</mat-radio-button>
                </mat-radio-group>
            </div>

            <div style="font-size: 15px; padding-bottom: 20px;">
                <label style="display:block; margin-bottom:6px;">Has Carrier been called?</label>
                <mat-radio-group [(ngModel)]="hasCarrierBeenCalled" name="hasCarrierBeenCalled">
                    <mat-radio-button value="yes" style="margin-right:12px;">Yes</mat-radio-button>
                    <mat-radio-button value="no">No</mat-radio-button>
                </mat-radio-group>
            </div>

            <mat-form-field class="pls">
                <mat-label style="font-size: 15px !important;">What has been impacted?</mat-label>
                <mat-select [(value)]="impactType">
                    <mat-option *ngFor="let option of impactTypesList" [value]="option.name">
                        {{ option.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="ple">
                <mat-label style="font-size: 15px !important;">Reason for the Issue?</mat-label>
                <mat-select [(value)]="reasonForIssueType" panelClass="custom-panel">
                    <mat-option *ngFor="let option of reasonForIssueTypesList" [value]="option.name">
                        {{ option.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <mat-dialog-content style="padding-top: 20px;" *ngIf="addNotes">
            <mat-form-field class="an">
                <mat-label style="padding:10px;">Add notes</mat-label>
                <textarea class="textinputupdate" matInput [(ngModel)]="note" (input)="onNoteInput($event)"></textarea>
                <mat-hint align="end">{{ (note || '').length }} characters</mat-hint>
            </mat-form-field>
            <div *ngIf="addReason">
                <mat-form-field class="an">
                    <mat-label style="padding:10px;">Manager's actions</mat-label>
                    <textarea class="textinputupdate" matInput [(ngModel)]="managerActions" (input)="onManagerActionsInput($event)"></textarea>
                    <mat-hint align="end">{{ (managerActions || '').length }} characters</mat-hint>
                </mat-form-field>
                <mat-form-field class="an">
                    <mat-label style="padding:10px;">Issue actions</mat-label>
                    <textarea class="textinputupdate" matInput [(ngModel)]="issueActions" (input)="onIssueActionsInput($event)"></textarea>
                    <mat-hint align="end">{{ (issueActions || '').length }} characters</mat-hint>
                </mat-form-field>
            </div>
            <div style="margin-top: 10px; padding: 0 16px;">
                <span [style.color]="isCharacterLimitExceeded() ? 'red' : (getRemainingCharacters() < 100 ? 'orange' : 'inherit')"
                      style="font-size: 12px; font-weight: 500;">
                    Total characters: {{ getTotalCharacterCount() }} / 1500
                    <span *ngIf="!isCharacterLimitExceeded()">({{ getRemainingCharacters() }} remaining)</span>
                    <span *ngIf="isCharacterLimitExceeded()" style="font-weight: bold;"> - Limit exceeded!</span>
                </span>
            </div>
        </mat-dialog-content>

        <div *ngIf="addInputLocation">
            <div class="map-container">
                <mat-form-field style="width:96%">
                    <input matInput id="search-input" placeholder="Search location" type="text" [formControl]="searchControl">
                </mat-form-field>

                <div><p>OR</p></div>

                <div style="display: flex; flex-direction: row;">
                    <mat-form-field class="custom-spacing" style="width:96%">
                        <input matInput id="search-input-latlng" placeholder="Enter Latitude,Longitude" type="text" [formControl]="searchLatLng"
                        (blur)="calculateDistanceAndDuration()">
                    </mat-form-field>
                </div>

                <agm-map #map style="height: 320px;width: 95%"
                    [latitude]="tour?.type === 'Collection' ? tour?.collectionLatitude : tour?.destinationLatitude"
                    [longitude]="tour?.type === 'Collection' ? tour?.collectionLongitude : tour?.destinationLongitude"
                    (mapReady)="onMapReady($event)"
                    (mapClick)="onMapClick($event)"
                    (zoom)="zoomChange($event)">

                    <agm-marker *ngIf="tour?.type === 'Delivery'" [latitude]="tour?.destinationLatitude" [longitude]="tour?.destinationLongitude"
                        [title]="'Next location: ' + (tour?.type === 'Collection' ? tour?.collectionAddress : tour?.destination) + '\nETA: ' + (tour?.estimatedDateTime | date: 'dd-MMM-yyyy HH:mm') + '\nDelta: ' + getTimeDifference(tour?.type === 'Collection' ? tour?.plannedLoadingEnd : tour?.plannedDeliveryEnd, tour?.estimatedDateTime)"
                        [iconUrl]="{ url: getIcon(tour?.type, tour?.updateBy), scaledSize: {width: 45,height: 55}}"
                        >
                        <agm-info-window>
                            {{tour?.destination}}
                        </agm-info-window>
                    </agm-marker>

                    <agm-marker *ngIf="tour?.type === 'Collection'" [latitude]="tour?.collectionLatitude" [longitude]="tour?.collectionLongitude"
                        [title]="'Next location: ' + (tour?.type === 'Collection' ? tour?.collectionAddress : tour?.destination) + '\nETA: ' + (tour?.estimatedDateTime | date: 'dd-MMM-yyyy HH:mm') + '\nDelta: ' + getTimeDifference(tour?.type === 'Collection' ? tour?.plannedLoadingEnd : tour?.plannedDeliveryEnd, tour?.estimatedDateTime)"
                        [iconUrl]="{url: getIcon(tour?.type, tour?.updateBy), scaledSize: {width: 45,height: 55}}"
                        >
                        <agm-info-window>
                            {{tour?.destination}}
                        </agm-info-window>
                    </agm-marker>

                    <agm-marker [latitude]="tour?.vehicleLat" [longitude]="tour?.vehicleLng" [draggable]="true"
                        (markerDragEnd)="onVehicleMarkerDragEnd($event)"
                         [title]="'Next location: ' + (tour?.type === 'Collection' ? tour?.collectionAddress : tour?.destination) + '\nETA: ' + (tour?.estimatedDateTime | date: 'dd-MMM-yyyy HH:mm') + '\nDelta: ' + getTimeDifference(tour?.type === 'Collection' ? tour?.plannedLoadingEnd : tour?.plannedDeliveryEnd, tour?.estimatedDateTime)"
                        [iconUrl]="tour.updateTypeName === 'Driver Rest Start' ? {url:'./assets/images/Driver-rest-icon.png', scaledSize: {width: 45,height: 55} } :{url:getTruckIcon((tour?.type === 'Collection' ? tour?.plannedLoadingEnd : tour?.plannedDeliveryEnd), tour?.estimatedDateTime, (tour?.type === 'Collection' ? tour?.actualCollectionDate : tour?.actualDeliveryDate)), scaledSize: {width: 45,height: 45}}">
                        <agm-info-window>
                            <strong>Reg Number: {{tour?.regNumber}}</strong><br>
                            <strong>Next location: {{tour?.type === 'Collection' ? tour?.collectionAddress : tour?.destination}}</strong><br>
                            <strong>ETA: {{tour?.estimatedDateTime | date: 'dd-MMM-yyyy HH:mm'}}</strong><br>
                            <strong>Delta: {{ getTimeDifference(tour?.type === 'Collection' ? tour?.plannedLoadingEnd : tour?.plannedDeliveryEnd, tour?.estimatedDateTime) }}</strong>
                        </agm-info-window>
                    </agm-marker>

                </agm-map>

            </div>



        </div>

        <div class="flex-item" *ngIf="addDates">
            <mat-form-field class="sd">
                <label>{{ isDriverRestEnd() ? "Select new ETA Date" : (condition === true ? "Select New Estimated Date" : "Select Date") }}</label>
                <input matInput [matDatepicker]="etaDatePicker" [(ngModel)]="selectedDate"
                    (click)="etaDatePicker.open()" style="margin-top: 15px">
                <mat-datepicker-toggle matSuffix [for]="etaDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #etaDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="st">
                <label>{{ isDriverRestEnd() ? "Select new ETA Time" : (condition === true ? "Select New Estimated Time" : "Select Time") }}</label>
                <input matInput type="time" [(ngModel)]="targetTime">
            </mat-form-field>
        </div>

        <div class="flex-item" *ngIf="addRestDates">
            <mat-form-field class="custom-spacing restchange" style="margin-right: 40px;">
                <label>Select Rest Start Date</label>
                <input matInput [matDatepicker]="etaDatePicker" [(ngModel)]="restStartDate"
                    (click)="etaDatePicker.open()" style="margin-top: 15px">
                <mat-datepicker-toggle matSuffix [for]="etaDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #etaDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="custom-spacing restchange">
                <label>Select Rest Start Time</label>
                <input matInput type="time" [(ngModel)]="restStartTargetTime">
            </mat-form-field>
        </div>

        <div class="flex-item" *ngIf="addRestDates">
            <mat-form-field class="custom-spacing restchange" style="margin-right: 40px;">
                <label>Select Rest End Date</label>
                <input matInput [matDatepicker]="etaDatePicker" [(ngModel)]="restEndDate"
                    (click)="etaDatePicker.open()" style="margin-top: 15px">
                <mat-datepicker-toggle matSuffix [for]="etaDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #etaDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="custom-spacing restchange">
                <label>Select Rest End Time</label>
                <input matInput type="time" [(ngModel)]="restEndTargetTime">
            </mat-form-field>
        </div>

    </mat-dialog-content>

    <div *ngIf="loading"><mat-dialog-actions align="end">
            <button style="font-size: 10px;
        margin-right: 5px;
        scale: 1;
        background: #bf1e2e;
        color: white;
        border-radius: 0px;
        text-shadow: none;
        box-shadow: none;
        flex: 1 1 100%;
        box-sizing: border-box;
        max-width: 50px;
        cursor: pointer;
        transition: background-color 0.3s;
        box-shadow: none !important;" mat-raised-button (click)="onCancelClick()">Cancel</button>
            <button style="font-size: 10px;
        margin-right: 5px;
        scale: 1;
        color: white;
        border-radius: 0px;
        text-shadow: none;
        box-shadow: none;
        flex: 1 1 100%;
        box-sizing: border-box;
        max-width: 50px;
        cursor: pointer;
        transition: background-color 0.3s;
        box-shadow: none !important;" [style.background-color]="isFormValid() ? ' #bf1e2e' : 'gray'"
                [disabled]="!isFormValid()" mat-raised-button (click)="onSaveClick()">Save</button>
        </mat-dialog-actions></div>
</mat-card>
